import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Select } from 'antd';
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { isBlankNullOrUndefined } from "../../../../swzutils/TypeUtils";
const TextTableFilter = ({ defaultValue = [""], placeholder, forceUppercase = false, onApplyFilter, onClearFilter, presenceFilter, }) => {
    const [value, setValue] = useState(defaultValue ? defaultValue[0] + "" : "");
    const inputRef = useRef(null);
    const [presenceSelectValue, setPresenceSelectValue] = useState(null);
    const presenceSelectRef = useRef(null);
    useEffect(() => {
        if (!isBlankNullOrUndefined(value)) {
            presenceFilter?.onApply(true);
            setPresenceSelectValue('PRESENT');
        }
    }, [value]);
    const onChange = (e) => {
        setValue(e.target.value);
    };
    const applyFilterClicked = () => {
        onApplyFilter([value]);
    };
    const clearFilterClicked = () => {
        setValue("");
        onClearFilter();
        presenceFilter?.onClear();
        setPresenceSelectValue(null);
    };
    const style = forceUppercase ? { textTransform: "uppercase" } : undefined;
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsx(Input, { ref: inputRef, placeholder: placeholder, value: value, style: style, onChange: onChange, onPressEnter: applyFilterClicked }), _jsx(Button, { type: "primary", onClick: applyFilterClicked, children: _jsx(SearchOutlined, {}) }), "\u00A0", _jsx(Button, { type: "default", onClick: clearFilterClicked, children: _jsx(CloseOutlined, {}) }), presenceFilter &&
                _jsxs(_Fragment, { children: [_jsx("br", {}), _jsx(Select, { value: presenceSelectValue, ref: presenceSelectRef, style: { width: '100%', paddingTop: '5px' }, allowClear: true, placeholder: presenceFilter.filter.placeholder, options: [
                                {
                                    label: presenceFilter.filter.labelPresent,
                                    value: 'PRESENT',
                                }, {
                                    label: presenceFilter.filter.labelAbsent,
                                    value: 'ABSENT',
                                }
                            ], onChange: (value) => {
                                setPresenceSelectValue(value);
                                // console.log("XXX", value);
                                if (value === 'PRESENT') {
                                    presenceFilter.onApply(true);
                                }
                                else if (value === 'ABSENT') {
                                    presenceFilter.onApply(false);
                                }
                                else {
                                    presenceFilter.onClear();
                                }
                            } })] })] }));
};
export default TextTableFilter;
